import { Component, Input, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { RecordsManager } from "../../modules/records/records-manager";

@Component({
  selector: "records-table-filter",
  templateUrl: "./table-filter.component.html",
  styleUrls: ["./table-filter.component.scss"],
})
export class TableFilterComponent<T extends object> implements OnInit {
  @Input() label!: Extract<keyof T, string>;

  form: FormGroup<{ text: FormControl<string | null> }>;

  constructor(private fb: FormBuilder, private recordsManager: RecordsManager<T>) {
    this.form = this.fb.group({
      text: [""],
    });
  }

  ngOnInit(): void {
    this.recordsManager.tableConfig?.type === "clientSide"
      ? this.clientSideFilter(this.form.get("text"))
      : this.serverSideFilter(this.form.get("text"));
  }

  clientSideFilter(control: AbstractControl | null) {
    if (!control) return;
    control.valueChanges.subscribe((value) => {
      let filterPredicate = (data: T, match: string) => {
        if (data[this.label] && typeof data[this.label] === "string") {
          return (data[this.label] as unknown as string)
            .toLowerCase()
            .includes(match.toLowerCase());
        }
        return data[this.label] && (data[this.label] as unknown as string).includes(match);
      };
      this.recordsManager.applySyncFilter(value, filterPredicate);
    });
  }

  serverSideFilter(control: AbstractControl | null) {
    if (!control) return;
    control.valueChanges
      .pipe(
        //filter((val) => !val || val.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap((val: string) =>
          this.recordsManager.applyAsyncFilter({
            searchBy: this.label,
            searchFor: val,
          })
        )
      )
      .subscribe();
  }
}
